
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenApiKeyRequestStatus } from './GenApiKeyRequestStatus';
import moment from 'moment';

export class GenApiKeyRequest {

    id: number;
    createdAt: moment.Moment;
    deniedReason: string;
    reason: string;
    reviewedBy: number;
    status: GenApiKeyRequestStatus;
    supportedSystems: string[];
    userId: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genApiKeyRequest: GenApiKeyRequest);
    constructor( id: number );

    constructor( input?: GenApiKeyRequest|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            if ( input.createdAt && typeof input.createdAt === 'string' ) {
                this.createdAt = moment(input.createdAt).utc();
            } else {
                this.createdAt = input.createdAt;
            }
            this.deniedReason = input.deniedReason; // string [string]
            this.reason = input.reason; // string [string]
            this.reviewedBy = input.reviewedBy; // int [number]
            this.status = (typeof input.status === 'string') ? GenApiKeyRequestStatus.forName(<string> input.status) : <any> input.status; // GenApiKeyRequestStatus
            this.supportedSystems = input.supportedSystems; // list [string]
            this.userId = input.userId; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenApiKeyRequest[] {
        if (arr && arr.map) {
          return arr.map(a => new GenApiKeyRequest(a));
        } else {
          return [];
        }
    }
}

